import React from 'react';
import './Popup.css'

const Popup = ({active, setActive, indexUtm, utm}) => {
    return (
        <div className={active ? "package-popup active" : "package-popup"} onClick={() => setActive(false)}>
            <div className='popup_container' onClick={e => e.stopPropagation()}>
                <h4 onClick={this} className='popup_title'>Registration for Career Track is now closed!</h4>
                <p onClick={this} className='popup_abstract popup_abstract--mb'>You can buy a Pro Track ticket and you will be granted access to the Pro track and Career Track as well. </p>
                <a className='trackButton' href={`https://geekle.us/ticket/1620464923433x986615051167465500?page=android${indexUtm !== -1 ? `&${utm}` : ''}`}>Join Pro Track 🔥</a>
            </div>
        </div>
    );
};


export default Popup